import { render, staticRenderFns } from "./StepNumber.vue?vue&type=template&id=c237442a&scoped=true&"
import script from "./StepNumber.vue?vue&type=script&lang=ts&"
export * from "./StepNumber.vue?vue&type=script&lang=ts&"
import style0 from "./StepNumber.vue?vue&type=style&index=0&id=c237442a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c237442a",
  null
  
)

export default component.exports